<div class="content-container">
  <div class="container login-container">
    <div class="row justify-content-center" *ngIf="status=='success'">
      <div class="col-md-12">
        <div class="alert alert-success rounded-0 p-2 text-center">
          <i class="fa fa-tick fa-2x"></i>
          <span>Profile update successful.</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center flex-column align-items-center">
      <div class="col-md-6">
        <div class="card square-edges bg-neutral-50">
          <div class="card-body">
            <h3>Profile</h3>
            <customer-profile (onSuccess)="SetStatus($event)"></customer-profile>
          </div>
        </div>
        <div class="col-1"></div>
      </div>
    </div>
  </div>
</div>
